import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

import {Warenuebernahme} from "../../types/warenuebernahme";
import {Bestellung} from "../../types/bestellung";

import { InputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-kopfdaten',
    imports: [
    InputComponent,
    TranslatePipe
  ],
    templateUrl: './kopfdaten.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./kopfdaten.component.css']
})
export class KopfdatenComponent {

  @Input() isBestellung = false;
  @Input() isBestellungUebernahme = false;
  @Input() warenuebernahme?: Warenuebernahme;
  @Input() bestellung?: Bestellung;
  @Output() lieferscheinnummerChange = new EventEmitter<string>();
}
